import React, { useRef } from "react";
import emailjs from "@emailjs/browser"; // ✅ updated package
import Navbar from "../components/Navbar";
import "../App.css";
import Footer from "../components/Footer";
import LiveChat from "../components/LiveChat";
import GetQuoteButton from "../components/GetQuoteButton";
import QAChatbot from "../components/QAChatBot";
import BackToTopButton from "../components/BackToTopButton";
import ScrollSocialIcons from "../components/ScrollSocialIcons";

const Contact = () => {
    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs
            .sendForm(
                "service_v7xwleq",
                "template_b9dzc2b",
                form.current,
                "nY-PyzSMsXXjQl2Id"
            )
            .then(
                (result) => {
                    alert("Message sent successfully!");
                    form.current.reset();
                },
                (error) => {
                    console.error("EmailJS Error:", error);
                    alert("Failed to send message. Please try again.");
                }
            );
    };

    return (
        <div>
            <Navbar />
            <section id="contact" className="contact-section">
                <div className="contact-container">
                    {/* Contact Info */}
                    <div>
                        <h2 className="contact-heading">Get in Touch</h2>
                        <p className="contact-paragraph">
                            "We're here to help 24/7. Have a question about our services or pricing? Our team is
                            ready to assist you with all your inquiries."
                        </p>
                        <div className="ccontact-info">
                            <p>📍 <strong>Address:</strong> 224/2, Ananda Bodhi Vihara Mawatha Rd, Athurugiriya, Sri Lanka</p>
                            <p>📞 <strong>Phone:</strong> <a href="tel:+94719645645">+94 719 645 645</a></p>
                            <p>✉️ <strong>Email:</strong> <a href="mailto:ciapinfo@ciap.ltd">ciapinfo@theciap.com</a></p>
                        </div>
                        <iframe
                            className="contact-map"
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15843.430587329696!2d79.94988214999999!3d6.884376200000005!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae24f783c4c9675%3A0x22f02f62a1f23933!2sAnanda%20Bodhi%20Vihara%20Mawatha%2C%20Athurugiriya%2010170!5e0!3m2!1sen!2slk!4v1718786700617!5m2!1sen!2slk"
                            allowFullScreen=""
                            loading="lazy"
                            title="CIAP Location - Athurugiriya"
                        />
                    </div>

                    {/* Contact Form */}
                    <div className="contact-form">
                        <h3>Send Us a Message</h3>
                        <form ref={form} onSubmit={sendEmail}>
                            <input type="text" name="name" placeholder="Your Name" required />
                            <input type="email" name="email" placeholder="Your Email" required />
                            <input type="text" name="subject" placeholder="Subject" required />
                            <textarea name="message" rows="5" placeholder="Your Message" required></textarea>
                            <button type="submit">Send Message</button>
                        </form>
                    </div>
                </div>
            </section>
            <LiveChat />
            <QAChatbot />
            <GetQuoteButton />
            <ScrollSocialIcons />
            <BackToTopButton />
            <Footer />
        </div>
    );
};

export default Contact;
